<template>
  <router-view />
</template>

<script>
// Used by generated nested menu containers so the page shell is mounted once.
export default {
  name: "RouteView",
};
</script>
